import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, TemplateRef, Inject } from '@angular/core';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { UtilService, VariablesService, StorageService, FundraiserService, VwoService } from '../../../../shared/services';
import { IFundraiser } from '../../../../fundraiser/models/fundraiser.model';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  @Input() public about;
  @Input() public documents;
  @Input() public comments;
  @Input() public supporters;
  @Input() public fundraiser: IFundraiser;
  @Input() public isLoading;
  @Input() public isFundraiserEnded;
  @Input() public updates;
  @Input() public donateBtnLabel;
  @Input() public sharedCounts;
  @Input() public basicInfo;
  @Input() public donationCard;
  @Output() public changeTab = new EventEmitter();
  @ViewChild('showMore', { static: true }) showMore: ElementRef;
  @ViewChild('aboutContainer', { static: true }) aboutContainer: ElementRef<HTMLElement>;
  isShown = false;
  defaultImg;
  currency;
  campaignUrl;
  isMobile;
  entity = { initials: null };
  public editForm: FormGroup;
  public goal_amount: FormControl;
  public appeal: FormControl;
  errorMessageGoal = {
    'min': 'Minimum amount should be greater than 2000',
  };

  userData;
  causeId = [4, 7, 59, 103, 150, 156, 159];
  formInfo = {
    'errorMessageGoal': {
      'placeholder': '',
      'min': 'Minimum amount should be greater than 2000',
    },
    'appeal': {
      'placeholder': 'Make an Appeal...',
      'error': {
        'minlength': 'Please enter minimum 4 characters',
        'maxlength': 'The ask a question field may not be greater than 300 characters'
      },
    },
  };

  /**Document slider config */
  docsSlideConfig: SwiperConfigInterface = {
    a11y: true,
    slidesPerView: 7,
    watchSlidesVisibility: true,
    direction: 'horizontal',
    spaceBetween: 0,
    keyboard: true,
    navigation: true,
    preloadImages: false,
    observer: true,
    observeParents: true,
    lazy: true,
    preventClicksPropagation: false,
    effect: '',
    coverflowEffect: {
      rotate: 30
    },
    breakpoints: {
      992: {
        slidesPerView: 'auto',
        init: true,
        spaceBetween: 15,
        centeredSlides: true,

      },
    }
  };

  constructor(
    public utilService: UtilService,
    public variablesService: VariablesService,
    public dialog: MatDialog,
    public storageService: StorageService,
    public fundraiserService: FundraiserService,
    public vwo: VwoService,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit() {
    this.isMobile = this.utilService?.isMobile();
    this.docsSlideConfig.effect = this.utilService.isMobile() ? 'coverflow' : 'slide',
    this.addClass();
    this.getCurrency();
    this.formatEntityData();
    this.initForm();
    this.campaignUrl = this.utilService.domain_details.domain_url + '/fundraiser/' + this.fundraiser?.custom_tag;
    this.variablesService.userData.subscribe((res) => {
      this.userData = res;
    });
  }

  initForm() {
    if (this.fundraiser && this.fundraiser?.support_campaign) {
      this.editForm = new FormGroup({
        // name: this.appeal = new FormControl('', [ Validators.required, Validators.min(2000)]),
        appeal: this.appeal = new FormControl(this.fundraiser?.support_campaign?.appeal, [
          Validators.required, Validators.minLength(4)
        ])
      });
    }
  }

  formatEntityData() {
    if (this.fundraiser?.support_campaign && this.fundraiser?.support_campaign?.entity) {
      this.entity.initials = this.setName(this.fundraiser.support_campaign.entity.fname);
    }
  }

  setName(name) {
    return this.utilService.getInitialsOfName(name);
  }

  /**Get the currency */
  getCurrency() {
    this.utilService.currency.subscribe({
      next: (res) => {
        this.currency = res;
      }
    });
  }
  /**Add the shadow effect on init */
  addClass() {
    const el: HTMLElement = this.showMore?.nativeElement;
    el.classList.add('show-more-effect');
  }

  /**Toggle the shadow effect */
  toggleClass() {
    if (this.isShown) {
      this.changeTab.emit('Updates');
    } else {
      const el: HTMLElement = this.showMore.nativeElement;
      const el1: HTMLElement = this.aboutContainer.nativeElement;
      el.classList.remove('show-more-effect');
      el1.classList.add('animate-container');
      this.isShown = true;
    }
  }
  /**check the length of the array */
  checkLength(arr) {
    return arr && arr.length ? true : false;
  }

  editAppeal(templateRef: TemplateRef<any>) {
    this.openDialogWithTemplateRef(templateRef);
  }

  openDialogWithTemplateRef(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      maxWidth: '100vw',
      width: this.utilService.isMobile() ? '385px' : '500px',
      height: this.utilService.isMobile() ? '370px' : '370px',
      panelClass: 'dialog-class'
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  getErrorMessage(control: FormControl) {
    switch (true) {
      case control.hasError('required'):
        return 'This field is required';
      case control.hasError('minlength'):
        return 'minimum 10 characters required';
    }
  }

  submitButton() {
    this.document.getElementById('submitBtn3').click();
  }

  checkOwner() {
    let returnVal = false;
    if (this.utilService.getUser()) {
      returnVal = this.fundraiser.support_campaign.entity.email === this.utilService.getUser()?.user?.email_id;
    }
    return returnVal;
  }

  checkError() {
    (<any>Object).values(this.editForm.controls).forEach(control => {
      control.markAsTouched();
    });
  }

  editFormSubmit() {
    if (this.editForm.valid) {
      this.isLoading = true;
      const data = {
        appeal: this.appeal.value
      };
      this.fundraiserService.editSupportingFr(this.fundraiser.id, this.fundraiser.support_campaign.id, data).subscribe(res => {
        this.isLoading = false;
        this.dialog.closeAll();
        window.location.reload();
      }, () => {
        this.isLoading = false;
      });
    } else {
      this.utilService.checkValidForm(this.editForm);
    }
  }

}
